export default __webpack_public_path__ + "static/media/house-4.0b701e33.jpg";